// @ts-check
import React from 'react';
import { VaComboBox } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import vaSelectAndComboBoxFieldMapping from './vaSelectAndComboBoxFieldMapping';
import { renderOptions } from './helpers';

export default function VaComboBoxField(props) {
  const mappedProps = vaSelectAndComboBoxFieldMapping(props);

  const labels = props.uiOptions?.labels || {};

  /**
   * @param {string} input - user typed input
   */
  function handleUserInput(input) {
    let newVal = '';
    for (const [key, value] of Object.entries(labels)) {
      if (input.toLowerCase() === value.label) {
        newVal = key;
        break;
      }
    }
    // user's input not valid
    props.childrenProps.onChange(newVal);
  }

  return (
    <VaComboBox
      {...mappedProps}
      placeholder={props?.uiOptions?.placeholder || null}
      value={
        props.childrenProps.formData ??
        props.childrenProps.schema.default ??
        undefined
      }
      onVaInputChange={e => handleUserInput(e?.detail?.value || '')}
    >
      {renderOptions(props.childrenProps.schema, labels)}
    </VaComboBox>
  );
}
